import React from "react"
import ThemeProvider from "@material-ui/styles/ThemeProvider"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import StudyRoutinePost from "../../../components/study-routine-post"
import theme from "../../../theme"

const summary = [
  {
    stage: "Primary",
    rhythm: "15 to 25 minutes, 2 to 3 days a week",
    focus: "Maps, places, environments, simple data, observation",
    habit: "Use one map, image, or example every study session",
  },
  {
    stage: "Lower secondary",
    rhythm: "25 to 40 minutes, 3 days a week",
    focus: "Geographic terms, diagrams, case studies, map skills, data",
    habit: "Link each concept to a place-based example",
  },
  {
    stage: "Upper secondary",
    rhythm: "45 to 60 minutes, 4 days a week",
    focus: "Case studies, fieldwork, data analysis, processes, extended responses",
    habit: "Practise using evidence from maps, graphs, statistics, and examples",
  },
  {
    stage: "Exam block",
    rhythm: "Timed responses plus case review",
    focus: "Command terms, case studies, map interpretation, data questions",
    habit: "Memorise flexible case-study evidence, not fixed paragraphs",
  },
]

const sections = [
  {
    title: "Primary: notice places and patterns",
    paragraphs: [
      "Primary geography study should use maps, photos, local places, weather, environments, and simple data. Students learn best when abstract ideas connect to real locations.",
      "A useful routine is to describe what they see, where it is, why it might be there, and how people or environments are affected.",
    ],
  },
  {
    title: "Lower secondary: connect concept and place",
    paragraphs: [
      "Lower secondary students need vocabulary, diagrams, map skills, graphs, and case-study examples. Each concept should have a place attached to it.",
      "Short responses can follow a simple pattern: define the idea, describe the pattern, support it with evidence, and explain the impact.",
    ],
  },
  {
    title: "Upper secondary: use evidence flexibly",
    paragraphs: [
      "Upper secondary geography requires data interpretation, fieldwork understanding, process explanation, and case-study evidence. Students should practise using maps, graphs, statistics, and examples together.",
      "Memorised paragraphs are brittle. Flexible evidence is stronger because it can answer different command terms and question angles.",
    ],
  },
  {
    title: "A simple weekly rhythm",
    paragraphs: [
      "Use a calendar for map skills, key terms, diagrams, case-study review, data questions, extended responses, and feedback review.",
      "A good geography routine always asks: where is it, why there, what pattern, what impact, and what evidence proves it.",
    ],
  },
]

const GeographyStudyRoutines = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <SEO
        title="Geography Study Plan by School Level"
        description="Plan geography study routines for primary, lower secondary, upper secondary, and exam periods with maps, case studies, data, fieldwork, and extended responses."
      />
      <StudyRoutinePost
        subject="Geography"
        title="Geography study routines for different school levels"
        intro="A strong geography routine connects concepts to real places, maps, data, case studies, and clear explanations."
        sharedCalendarUrl="https://app.schoolcalendar.me/calendar/spotty-grasshopper-28"
        image="blog-geography.png"
        imageAlt="Geography study planning"
        summary={summary}
        sections={sections}
      />
    </Layout>
  </ThemeProvider>
)

export default GeographyStudyRoutines
